import { convertSortToQueryString } from "@sscs/utils";
import { SHARED_REPORTS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  DeleteReportLinkRequest,
  SendReportInvitesRequest,
  SendReportInvitesResponse,
  ShareReportRequest,
  ShareReportResponse,
  SharedReportLinkRecipientRequest,
  SharedReportLinkRecipientResponse,
  SharedReportLinksRequest,
  SharedReportLinksResponse,
  UnshareReportRequest,
  UpdateReportLinkRequest,
} from "../types";

export const sharedReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    shareReport: build.mutation<ShareReportResponse, ShareReportRequest>({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.version_id}/share-report`,
        method: "POST",
        body: {
          report_type: queryArg.report_type,
          settings: queryArg.settings,
        },
      }),
      invalidatesTags: ["SharedReports"],
    }),
    unshareReport: build.mutation<void, UnshareReportRequest>({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}/unshare-report`,
        method: "DELETE",
      }),
      invalidatesTags: ["SharedReports"],
    }),
    getSharedReportLinks: build.query<
      SharedReportLinksResponse,
      SharedReportLinksRequest
    >({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.version_id}`,
        params: {
          report_type: queryArg.report_type,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sort_by: convertSortToQueryString(queryArg.sort),
          active_only: queryArg.filter.active_only,
        },
      }),
      providesTags: ["SharedReports"],
    }),
    updateReportLink: build.mutation<void, UpdateReportLinkRequest>({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["SharedReports"],
    }),
    deleteReportLink: build.mutation<void, DeleteReportLinkRequest>({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SharedReports", "LatestReport"],
    }),
    getSharedReportLinkRecipients: build.query<
      SharedReportLinkRecipientResponse,
      SharedReportLinkRecipientRequest
    >({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}/recipients`,
      }),
    }),
    sendInvites: build.mutation<
      SendReportInvitesResponse,
      SendReportInvitesRequest
    >({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}/recipients`,
        method: "POST",
        body: {
          recipients: queryArg.recipients,
          message: queryArg.message,
        },
      }),
      invalidatesTags: ["SharedReports"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useShareReportMutation,
  useUnshareReportMutation,
  useGetSharedReportLinksQuery,
  useUpdateReportLinkMutation,
  useDeleteReportLinkMutation,
  useGetSharedReportLinkRecipientsQuery,
  useSendInvitesMutation,
} = sharedReportsApi;
